import React, { useContext, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField';
import BooleanInput from '@wix/da-ds/pkg/formControls/dsPresets/BooleanInput';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import { CustomExclusiveFieldName } from '../../types';

import s from './DisplayOptionsField.scss';

interface Props {}

const DisplayOptionsField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const id = useId();
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({
    name: CustomExclusiveFieldName.DISPLAY_RESOLUTION,
    control,
  });

  const items = [
    { label: 'Original', value: 'original' },
    { label: 'Size: 400 pixels wide', value: '400w' },
    { label: 'Size: 600 pixels wide', value: '600w' },
    { label: 'Size: 800 pixels wide', value: '800w' },
    { label: 'Size: 900 pixels wide', value: '900w' },
    { label: 'Size: 1024 pixels wide', value: '1024w' },
    { label: 'Size: 1280 pixels wide', value: '1280w' },
    { label: 'Size: 1600 pixels wide', value: '1600w' },
  ];

  return (
    <FormElement
      inputId={id}
      className={s['root']}
      label={
        <InputLabelText>
          {t('customExclusivePopup.form.displayResolution.label')}
        </InputLabelText>
      }
    >
      <div className={s['inputs']}>
        <SelectField
          id={id}
          className={s['display-resolution']}
          label={t('customExclusivePopup.form.displayResolution.label')}
          items={items}
          value={value}
          onSelect={onChange}
          withBlankOption={false}
          isLabelHidden
        />
        <BooleanInput
          id={id}
          label={t('deviationSubmit.form.addWatermark.label')}
          onChange={onChange}
          value={value}
          size={isMobile ? 'large' : 'small'}
          noBottomSpacing
        />
      </div>
    </FormElement>
  );
};
DisplayOptionsField.displayName = 'DisplayOptionsField';

export default DisplayOptionsField;
